<template>
    <div>
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>
                            <button :disabled="disabled" @click="agregarDetalle" class="btn-success" type="button"><i class="fa fa-plus"></i></button>
                        </th>
                        <th>Destinatario</th>
                        <th>Dirección</th>
                        <th>Motivo de traslado</th>
                        <th>Ruta</th>
                        <th># Documento</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(detalle, index) in modelValue" :key="index">
                        <td>
                            <button :disabled="disabled" @click="editarDetalle(index)" class="btn-info btn--text" type="button"><i class="fa fa-edit"></i></button>
                        </td>
                        <td :tooltip="detalle.nombre_destinatario!==''?detalle.nombre_destinatario:'Seleccione...'">{{ detalle.nombre_destinatario }}</td>
                        <td :tooltip="detalle.direccion_destinatario!==''?detalle.direccion_destinatario:'Seleccione...'">{{ detalle.direccion_destinatario }}</td>
                        <td :tooltip="detalle.motivo_traslado!==''?detalle.motivo_traslado:'Seleccione...'">{{ detalle.motivo_traslado }}</td>
                        <td :tooltip="detalle.ruta!==''?detalle.ruta:'Seleccione...'">{{ detalle.ruta }}</td>
                        <td :tooltip="detalle.numero_documento!==''?detalle.numero_documento:'Seleccione...'">{{ detalle.numero_documento }}</td>
                        <td>
                            <button :disabled="disabled" @click="eliminarDetalle(index)" class="btn-danger btn--text" type="button"><i class="fa fa-trash"></i></button>
                        </td>
                    </tr>
                    <tr v-show="modelValue.length === 0">
                        <td colspan="7">
                            <strong>No se ha agregado detalles.</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <modal :clickToClose="false" name="detalleGuiaRemision" width="70%" height="auto" scrollable>
            <detalle-guia-remision @personaActualizada="personaActualizada" :detallesActuales="modelValue" @cancelar="cancelarDetalle" @input="inputDetalle" v-model="selectedDetalle"></detalle-guia-remision>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        disabled : {
            type : Boolean, 
            required : false,
            default : false
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            currentIndex : -1,
            esNuevoDetalle : false,
            selectedDetalle : null
        };
    },
    methods : {
        personaActualizada : function (email, telefono) {
            this.$emit('personaActualizada', email, telefono)
        },
        agregarDetalle : function () {
            this.esNuevoDetalle = true;
            let nuevoDetalle = {
                    id_destinatario : '',
                    identificacion_destinatario : '',
                    nombre_destinatario : '',
                    direccion_destinatario : '',
                    motivo_traslado : '',
                    documento_aduanero : '',
                    cod_establecimiento : '',
                    ruta : '',
                    cod_doc_sustento : '',
                    numero_documento : '',
                    numero_aut_documento : '', 
                    fecha_emision_doc : '',
                    detalles : [],
                    id_comprobante : '',
                    email : '',
                    telefono : ''
                };
            this.currentIndex = this.modelValue.push(nuevoDetalle) - 1;
            this.selectedDetalle = JSON.parse(JSON.stringify(nuevoDetalle));
            this.$modal.show('detalleGuiaRemision');
        },
        cancelarDetalle : function () {
            if (this.esNuevoDetalle)
            {
                this.modelValue.splice(this.currentIndex, 1);
                this.esNuevoDetalle = false;
            }
            this.$modal.hide('detalleGuiaRemision');
        },
        eliminarDetalle : function (index) {
            let that = this;
            swal({
                title: '¿Desear quitar este detalle?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Quitar',
                cancelButtonText : 'No'
            }).then((result) => {
                if (result.value)
                {
                    that.$emit('personaEliminada', that.modelValue[index], index);
                    that.modelValue.splice(index, 1);   
                }
            });
        },
        editarDetalle : function (index) {
            this.currentIndex = index;
            this.selectedDetalle = JSON.parse(JSON.stringify(this.modelValue[index]));
            this.$modal.show('detalleGuiaRemision');
        },
        inputDetalle : function (detalle) {
            this.modelValue.splice(this.currentIndex, 1, detalle);
            this.$modal.hide('detalleGuiaRemision');
            this.esNuevoDetalle = false;
            this.$emit('personaSeleccionada', detalle, this.currentIndex);
            this.currentIndex = -1;
        }
    },
    watch : {
        value : function (value) {
            this.modelValue = value;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaDetalleGuiaRemision.vue